import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/29/footer';
import Header from '../components/29/header';
import HomePage from '../pages/29/home_page';
import AboutPage from '../pages/29/about_page';
import MembershipPage from '../pages/29/membership_page';
import ContactPage from '../pages/29/contact_page';

export default function JewelleryTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
                membershipPage={MembershipPage}
                contactPage={ContactPage}
            />
            <Footer />
        </React.Fragment>
    )
}
